import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "row g-2 mb-3"
}
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "col-12 col-md-6" }
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["title", "onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownConsulte = _resolveComponent("DropDownConsulte")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("div", {
      class: "modal-consulte-bg",
      key: _ctx.refreshCounter
    })),
    (_openBlock(), _createElementBlock("div", {
      ref: "dialogRef",
      class: "modal fade show",
      tabindex: "-1",
      role: "dialog",
      key: _ctx.refreshCounter,
      "aria-labelledby": _ctx.idTitulo,
      "aria-modal": "true",
      style: {"display":"unset","border-radius":"var(--ct-modal-inner-border-radius)"},
      onKeydown: [
        _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
        _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.manterFocoDentro && _ctx.manterFocoDentro(...args)))
      ]
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("h4", {
                class: "modal-title",
                id: _ctx.idTitulo
              }, _toDisplayString(_ctx.titulo), 9, _hoisted_5)
            ], true),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              "aria-label": "Fechar"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.podeFiltrarEscolaESituacao)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", {
                      class: "form-label",
                      for: `${_ctx.idBase}-escola`
                    }, "Escola", 8, _hoisted_9),
                    _createVNode(_component_DropDownConsulte, {
                      id: `${_ctx.idBase}-escola`,
                      modelValue: _ctx.escolaFiltro,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.escolaFiltro) = $event)),
                      onChange: _ctx.montarDataSource,
                      array: _ctx.escolasDisponiveis,
                      "row-label": "nome",
                      "row-value": "id",
                      placeholder: "Desconsiderar escola (toda a rede)",
                      "valor-vazio": 0
                    }, null, 8, ["id", "modelValue", "onChange", "array"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", {
                      class: "form-label",
                      for: `${_ctx.idBase}-status`
                    }, "Situação", 8, _hoisted_11),
                    _createVNode(_component_DropDownConsulte, {
                      id: `${_ctx.idBase}-status`,
                      modelValue: _ctx.statusFiltro,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statusFiltro) = $event)),
                      "aria-describedby": `${_ctx.idBase}-status-ajuda`,
                      onChange: _ctx.montarDataSource,
                      placeholder: ''
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("option", { value: "Desconsiderar" }, "Desconsiderar", -1),
                        _createElementVNode("option", { value: "Enturmados" }, "Enturmados", -1),
                        _createElementVNode("option", { value: "NaoEnturmados" }, "Não enturmados", -1),
                        _createElementVNode("option", { value: "Matriculados" }, "Matriculados", -1),
                        _createElementVNode("option", { value: "NaoMatriculados" }, "Não matriculados", -1)
                      ]))]),
                      _: 1
                    }, 8, ["id", "modelValue", "aria-describedby", "onChange"]),
                    _createElementVNode("p", {
                      id: `${_ctx.idBase}-status-ajuda`,
                      class: "form-text"
                    }, _toDisplayString(_ctx.ajudaSituacao), 9, _hoisted_12)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.erroPesquisa ? 'alert alert-danger' : 'visually-hidden'),
              role: "alert"
            }, _toDisplayString(_ctx.erroPesquisa), 3),
            _createVNode(_component_ConsulteGrid, {
              columns: _ctx.rows,
              "data-source": _ctx.dataSource,
              actions: true,
              hideHeader: true,
              onlySearchHeader: true
            }, {
              header: _withCtx(() => [...(_cache[6] || (_cache[6] = []))]),
              botaoSelecionar: _withCtx((context) => [
                _createElementVNode("button", {
                  type: "button",
                  title: `Selecionar ${context.row.nome}`,
                  onClick: ($event: any) => (_ctx.selecionarRegistro(context.row)),
                  class: "btn btn-link p-0 border-0 align-baseline font-18 text-success me-2",
                  style: {"margin-right":"5px"},
                  "aria-label": `Selecionar ${context.row.nome}`
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", {
                    class: "uil-arrow-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))], 8, _hoisted_13)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ])
        ])
      ])
    ], 40, _hoisted_1))
  ], 64))
}